<div class="chip-group row" *ngIf="chipList?.length">
    <div *ngFor="let chip of chipList" class="row ps-2">
        <button class="chip-container" (click)="onChipSelection(chip)">
            <img *ngIf="chip.iconUrl" class="chip-icon" [src]="chip.iconUrl" placement="left">
            <span class="chip-content">{{chip.value }}</span>
        </button>
    </div>